/** trims a full date string to the length needed to pre-populate the expiration date field */
export const trimExpirationDate = (expirationDate: string, hasFullExpirationDate?: boolean) =>
  expirationDate.slice(0, hasFullExpirationDate ? 10 : 7);
